import { connect } from 'react-redux';
import { ModalTransfer as ModalTransferComponent } from './modal-transfer.component';
import { AppState } from '../../app.state';

export const ModalTransfer = connect((sState: AppState) => ({ sState }))(
  ModalTransferComponent as any
) as unknown as typeof ModalTransferComponent;
